import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
//import PropTypes from 'prop-types'

const ImageComponent = styled(Img)`
  -webkit-animation-name: fade;
  -webkit-animation-duration: 2s;
  animation-name: fade;
  animation-duration: 2s;

  @-webkit-keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

const SlideShow = () => {
  const [index, setIndex] = React.useState(0)
  const [numberOfImages, setNumberOfImages] = React.useState(0)
  const [imageToShow, setImageToShow] = React.useState([])

  // allFile : Obtiene todas las IMAGENES que estan en un subdirectorio
  // allMarkdownRemark : Obtiene los MD de un directorio especifico
  const allImagesQuery = graphql`
    query {
      allFile(
        filter: {
          relativeDirectory: { eq: "slide" }
          extension: { regex: "/(png)|(jpg)|(jpeg)/" }
        }
      ) {
        totalCount
        edges {
          node {
            base
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
            publicURL
            base
          }
        }
      }
      allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: { fileAbsolutePath: { regex: "/(/slider)/.*.md$/" } }
      ) {
        edges {
          node {
            id
            excerpt(pruneLength: 100)
            frontmatter {
              path
              title
              image
              visible
            }
          }
        }
      }
    }
  `

  // Ejecuta la Query
  const {
    allFile: { edges: images }, //destructuring
    allMarkdownRemark,
  } = useStaticQuery(allImagesQuery)

  // Si no se han cargado las imagenes al estado, se evaluan y se cargan
  if (numberOfImages === 0) {
    // Obtenemos la info y estado de cada imagen desde el MD
    const md = allMarkdownRemark.edges

    // Aca guardaremos solo las imagenes que tienen su estado visible
    const imagesWithVisibleStatus = []

    // Iteramos sobre todas las imagenes encontradas en la carpeta
    images.forEach(image => {
      // Obtenemos el nombre de la imagen
      const imageName = image.node.base

      // Iteramos sobre los MD con la info de cada imagen
      md.forEach(element => {
        // Obtenemos el esatdo de la imagen desde el MD
        const statusIsVisible = element.node.frontmatter.visible
        // Obtenemos el el nombre de la imagen de ese MD
        const basePathImage = element.node.frontmatter.image
        const nameThisImage = basePathImage.split("/").slice(-1)[0]

        // Evaluamos si la imagen tiene su estado visible
        if (imageName === nameThisImage && statusIsVisible) {
          // Si su estado es visible, la agregamos al array
          imagesWithVisibleStatus.push(image)
        }
      })
    })

    // Seteamos el número de imagenes con estado visible
    setNumberOfImages(imagesWithVisibleStatus.length)
    // Setetamos el array con las imagenes
    setImageToShow(imagesWithVisibleStatus)
  }

  // Timer que se encarga de cambiar las imagenes del slide cada X milisegundos
  React.useEffect(() => {
    const timer = setInterval(() => {
      if (index === numberOfImages - 1) {
        // total number of images minus 1
        setIndex(0)
      } else {
        setIndex(prev => prev + 1)
      }
    }, 5000) //duration
    return () => clearInterval(timer) //cleanup
  }, [index]) //compare

  return (
    <>
      <h3>Ejemplo de slide con auto show</h3>

      {imageToShow.length > 0 && (
        <ImageComponent
          style={{ width: "100%", height: "200px" }}
          fluid={imageToShow[index].node.childImageSharp.fluid}
          alt={imageToShow[index].node.base.split(".")[0]}
        />
      )}
    </>
  )
}

export default SlideShow
